/* eslint-disable */
import { PluginContainerData } from './common.js';

import { GIFData_GIFType } from './plugin_gif.enums.js';

export interface GIFData {
  /** Styling for the GIF's container. */
  containerData?: PluginContainerData;
  /** The source of the full size GIF. */
  original?: GIF;
  /** The source of the downsized GIF. */
  downsized?: GIF;
  /** Height in pixels. */
  height: number;
  /** Width in pixels. */
  width: number;
  /** Type of GIF (Sticker or NORMAL). Defaults to `NORMAL`. */
  gifType: GIFData_GIFType;
}

export function gIFData_GIFTypeFromJSON(object: any): GIFData_GIFType {
  switch (object) {
    case 0:
    case "NORMAL":
      return GIFData_GIFType.NORMAL;
    case 1:
    case "STICKER":
      return GIFData_GIFType.STICKER;
    case -1:
    case "UNRECOGNIZED":
    default:
      return GIFData_GIFType.UNRECOGNIZED;
  }
}

export function gIFData_GIFTypeToJSON(object: GIFData_GIFType): string {
  switch (object) {
    case GIFData_GIFType.NORMAL:
      return "NORMAL";
    case GIFData_GIFType.STICKER:
      return "STICKER";
    default:
      return "UNKNOWN";
  }
}

export interface GIF {
  /** GIF format URL. */
  gif?: string;
  /** MP4 format URL. */
  mp4?: string;
  /** Thumbnail URL. */
  still?: string;
}

const baseGIFData: object = {
  height: 0,
  width: 0,
  gifType: GIFData_GIFType.NORMAL,
};

export const GIFData = {
  fromJSON(object: any): GIFData {
    const message = { ...baseGIFData } as GIFData;
    message.containerData =
      object.containerData !== undefined && object.containerData !== null
        ? PluginContainerData.fromJSON(object.containerData)
        : undefined;
    message.original =
      object.original !== undefined && object.original !== null
        ? GIF.fromJSON(object.original)
        : undefined;
    message.downsized =
      object.downsized !== undefined && object.downsized !== null
        ? GIF.fromJSON(object.downsized)
        : undefined;
    message.height =
      object.height !== undefined && object.height !== null
        ? Number(object.height)
        : 0;
    message.width =
      object.width !== undefined && object.width !== null
        ? Number(object.width)
        : 0;
    message.gifType =
      object.gifType !== undefined && object.gifType !== null
        ? gIFData_GIFTypeFromJSON(object.gifType)
        : GIFData_GIFType.NORMAL;
    return message;
  },

  toJSON(message: GIFData): unknown {
    const obj: any = {};
    message.containerData !== undefined &&
      (obj.containerData = message.containerData
        ? PluginContainerData.toJSON(message.containerData)
        : undefined);
    message.original !== undefined &&
      (obj.original = message.original
        ? GIF.toJSON(message.original)
        : undefined);
    message.downsized !== undefined &&
      (obj.downsized = message.downsized
        ? GIF.toJSON(message.downsized)
        : undefined);
    message.height !== undefined && (obj.height = Math.round(message.height));
    message.width !== undefined && (obj.width = Math.round(message.width));
    message.gifType !== undefined &&
      (obj.gifType = gIFData_GIFTypeToJSON(message.gifType));
    return obj;
  },
};

const baseGIF: object = {};

export const GIF = {
  fromJSON(object: any): GIF {
    const message = { ...baseGIF } as GIF;
    message.gif =
      object.gif !== undefined && object.gif !== null
        ? String(object.gif)
        : undefined;
    message.mp4 =
      object.mp4 !== undefined && object.mp4 !== null
        ? String(object.mp4)
        : undefined;
    message.still =
      object.still !== undefined && object.still !== null
        ? String(object.still)
        : undefined;
    return message;
  },

  toJSON(message: GIF): unknown {
    const obj: any = {};
    message.gif !== undefined && (obj.gif = message.gif);
    message.mp4 !== undefined && (obj.mp4 = message.mp4);
    message.still !== undefined && (obj.still = message.still);
    return obj;
  },
};
